// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + {"1005":"wr-reply-box","4129":"reviews-action-sheet-modal","8814":"filter-sort-modal"}[chunkId] + ".chunk.min.css";
};